/* import __COLOCATED_TEMPLATE__ from './list-count.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();